import { render } from "./PreviewTweakChat.vue?vue&type=template&id=c3b9dfa6&scoped=true"
import script from "./PreviewTweakChat.vue?vue&type=script&lang=js"
export * from "./PreviewTweakChat.vue?vue&type=script&lang=js"

import "./PreviewTweakChat.vue?vue&type=style&index=0&id=c3b9dfa6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b9dfa6"]])

export default __exports__